import { Platform, Settings } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { createSecureAuthStorage } from './secureAuthStorage';
import { createNativeCredentialStorage } from './nativeCredentialStorage';

// No-op storage for SSR (Node.js) where window/localStorage are unavailable.
// Zustand persist will harmlessly skip get/set during server-side rendering.
export const noopStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

// AsyncStorage's native module on macOS doesn't persist writes to disk.
// Use NSUserDefaults for preferences only. Auth is routed to Keychain below.
const macOSStorage = Platform.OS === 'macos' ? {
  getItem: (key) => {
    const val = Settings.get(key);
    return Promise.resolve(val != null ? val : null);
  },
  setItem: (key, value) => {
    Settings.set({ [key]: value });
    return Promise.resolve();
  },
  removeItem: (key) => {
    Settings.set({ [key]: null });
    return Promise.resolve();
  },
} : null;

let nativeStorage;

/** Uses secure native auth storage, retaining AsyncStorage on older mobile binaries. */
export function getStorage() {
  if (Platform.OS === 'web') {
    return typeof window !== 'undefined' ? localStorage : noopStorage;
  }
  if (!nativeStorage) nativeStorage = createSecureAuthStorage(
    Platform.OS === 'macos' ? macOSStorage : AsyncStorage, createNativeCredentialStorage());
  return nativeStorage;
}
